<template>
  <ui-menu
    v-model="menu"
    :content-class="contentClass + ' main-menu-events'"
    :location="location"
    :offset="offset"
    :close-on-content-click="true"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }" :value="menu" />
    </template>

    <template #menu>
      <navbar-boost-view-menu
        background-color="transparent"
        :change-plan-click="changePlanClick"
      />
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import NavbarBoostViewMenu from '@/views/layout/navigation/navbar-boost-view-menu.vue';

defineProps<{
  changePlanClick?: () => void;
  contentClass?: string;
  location?: string;
  offset?: [number, number];
  closeMenu?: () => void;
}>();

const menu = ref(false);
</script>
